import axios from "axios";
import agent from "../api/agent";

export interface OrderFilter {
  start_date?: string;
  end_date?: string;
  status_id?: number;
  org_id?: number;
  user_id?: number;
  outlet_id?: number;
  orderId?: string;
}

export interface CreateOrderPost {
  outlet_id: number;
}

export const createOrder = async (req:CreateOrderPost) => {
  const result = await agent.Orders.createOrder(req);
  return result;
};

export const getOrders = async (filters:OrderFilter) => {
  const result = await agent.Orders.getorders(filters);
  return result;
};

export const getOrderById = async (orderId: string | number) => {
  const response = await axios.get(`/orders/${orderId}`);
  return response.data;
};

export const cancelOrder = async (orderId: string | number) => {
  const response = await axios.get(`/orders/cancel-order/${orderId}`);
  return response.data;
};
